import { Flex, NumberInput, Text } from '@mantine/core'
import { ReactNode } from 'react'

import FakeSelector from '@/app/[locale]/price/[slug]/_components/Trade/FakeSelector'
import styles from '@/app/[locale]/price/[slug]/_components/Trade/PriceConvertor/index.module.css'

interface ConverterInputProps {
  value: string | number
  onChange: (val: string | number) => void
  onSelectorClick: () => void
  icon: ReactNode
  label: string
}

const inputContainerStyle = {
  borderRadius: 16,
  height: 80,
  padding: '24px',
  backgroundColor: 'transparent',
  border: '1px solid var(--half-px-Stroke, rgba(255, 255, 255, 0.15))',
  alignItems: 'center',
}

export function ConverterInput({
  value,
  onChange,
  onSelectorClick,
  icon,
  label,
}: ConverterInputProps) {
  return (
    <Flex style={inputContainerStyle} gap={8}>
      <NumberInput
        value={value}
        onChange={onChange}
        variant="unstyled"
        flex={1}
        thousandSeparator=","
        classNames={{ input: styles.fromNumber }}
        hideControls
      />
      <FakeSelector
        bg="var(--bg-surface-primary)"
        onClick={onSelectorClick}
        content={
          <Flex align="center">
            {icon}
            <Text fz={14} fw={500} lh="20px" lts={0.14} ml={8} c="var(--content-primary)">
              {label}
            </Text>
          </Flex>
        }
      />
    </Flex>
  )
}
